import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  ViewChild,
  ElementRef,
  TemplateRef
} from '@angular/core';
import { FormAttributeType } from '@eview/core/domain/form/form-attribute';
import { GoogleGeocodingService } from '@eview/features/ui/map/google-geocoding.service';
import { AppState } from '@eview/core/store/states/app.state';
import {
  EFormAttributeActions,
  FormAttributeBaseComponent,
  FormAttributeUnresolvedAddress
} from '@eview/features/ui/post-editor/form-attribute-base.component';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { ToastType } from '../../../toast/toast.component';
import { ToastService } from '../../../toast/toast.service';
import {
  ETagSelectorActions,
  TagSelectorChange,
  TagSelectorSetById,
  TagSelectorTouched
} from '../tag-selector/tag-selector.component';
import { MediaService } from '@eview/core/domain/media/media.service';
import { TagHelpers } from '@eview/core/domain/tags/tag.helpers';
import { selectMap } from '@eview/core/store/selectors/map.selector';
import { SimulateUserClickedMap } from '@eview/core/store/actions/map.actions';
import { FilterHelpers } from '@eview/core/domain/filters/filters.helper';
import { FilterItem, RiskFilters } from '@eview/core/domain/post/post';
import { Output, EventEmitter } from '@angular/core';
import { environment } from '@eview/core/environments/environment';
import { TableNumbersInputComponent } from '../table-numbers-input/table-numbers-input.component';
import { VulnerabilityRowsInputComponent } from '../vulnerability-rows-input/vulnerability-rows-input.component';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { SearchableSelectOption } from '@eview/features/ui/searchable-select/searchable-select.component';
import {
  VulnerabilityRow,
  encodeVulnerabilityRows,
  isRepeatableRowsAttribute,
  parseVulnerabilityRows,
  resolveRowsCatalog
} from '@eview/core/domain/form/vulnerability-rows';
import {
  blockIncidentLongTextKeypress,
  blockIncidentLongTextPaste,
  hasInvalidIncidentLongText
} from '../../validators/incident-long-text.validation';
import {
  blockTitleTextKeypress,
  blockTitleTextPaste,
  hasInvalidTitleText
} from '../../validators/title-text.validation';
import * as moment from 'moment';
import { assertReadableUploadFile } from '@eview/core/domain/media/readable-file.validation';

@Component({
  selector: 'eview-form-attribute',
  templateUrl: 'form-attribute.component.html',
  styleUrls: ['form-attribute.component.scss']
})
export class FormAttributeComponent extends FormAttributeBaseComponent
  implements OnInit, OnDestroy {
  @ViewChild('searchInput') searchInput: ElementRef;
  @ViewChild('mediaConfirmModal') mediaConfirmModalTpl: TemplateRef<unknown>;
  
  public model: any;
  public formatter = (result: any) => {
    if (!result) return '';
    if (typeof result === 'string') return result;
    return result.display_name || result.name || result.address || '';
  };

  public resultFormatter = (result: any) => {
    if (!result) return '';
    if (typeof result === 'string') return result;
    
    const name = result.name || '';
    const address = result.address || result.display_name || '';
    
    if (name && address && name !== address) {
      return `${name} - ${address}`;
    }
    return address || name;
  };
  protected environment = environment;

  @Output() getformAttributesExUpdate = new EventEmitter<string>();
  @Output() getformAttributesExUpdateZone = new EventEmitter<string>();
  @ViewChild('tableNumbersInput') tableNumbersInput: TableNumbersInputComponent;
  @ViewChild('vulnerabilityRowsInput')
  vulnerabilityRowsInput: VulnerabilityRowsInputComponent;

  /** Taxonomy key for tag fields (bound into eview-tag-selector). */
  tagTaxonomyKey = '';

  mapRegions:any = [];
  filters: FilterItem[] = [];
  NewFormAttribute: any = [];
  RiskFilters = RiskFilters;
  /** Multi-upload: compact array of File or existing server objects (no parallel "slots" UI). */

  /** File chosen in the picker, awaiting user confirmation in the modal. */
  pendingConfirmFile: File | null = null;
  /** Slot index for multi-file fields; null = single field. -1 = append with single multi picker. */
  pendingConfirmSlotIndex: number | null = null;
  private pendingConfirmPreviewUrl: string | null = null;
  /** Sanitized blob URL for img (Angular may strip raw blob: URLs). */
  pendingConfirmImageSafe: SafeUrl | null = null;
  private pendingConfirmPdfBlobUrl: string | null = null;
  /** Sanitized blob URL for PDF iframe preview. */
  pendingConfirmPdfSafe: SafeResourceUrl | null = null;
  private mediaConfirmModalRef: NgbModalRef | null = null;

  private readonly mediaConfirmModalOptions: NgbModalOptions = {
    centered: true,
    backdrop: 'static',
    scrollable: true,
    windowClass: 'media-upload-confirm-modal',
  };

  constructor(
    store: Store<AppState>,
    private actions$: Actions,
    googleGeocodingService: GoogleGeocodingService,
    @Inject(ViewContainerRef) private viewContainerRef: ViewContainerRef,
    private toast: ToastService,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    mediaService: MediaService
  ) {
    super(store, actions$, googleGeocodingService, mediaService);

    this.toast.setViewContainerRef(this.viewContainerRef);

    this.subs = new Subscription();

  }

  ngOnInit() {
    super.ngOnInit();

    // Initialize numeros_mesa from semicolon-separated string in array
    if (this.FormAttribute.key === 'numeros_mesa') {
      // Check both this.value and FormAttribute.value for editing
      const sourceValue = this.value || this.FormAttribute.value;
      console.log('numeros_mesa sourceValue:', sourceValue);
      
      if (Array.isArray(sourceValue) && sourceValue.length > 0) {
        if (typeof sourceValue[0] === 'string' && sourceValue[0].includes(';')) {
          // Split semicolon-separated string
          this.value = sourceValue[0].split(';').filter(v => v);
        } else if (typeof sourceValue[0] === 'string') {
          // Single value
          this.value = [sourceValue[0]];
        } else {
          this.value = sourceValue;
        }
      } else if (typeof sourceValue === 'string' && sourceValue) {
        // Direct string value
        this.value = sourceValue.split(';').filter(v => v);
      } else {
        this.value = [];
      }
      
      console.log('numeros_mesa parsed value:', this.value);
    }

    if (isRepeatableRowsAttribute(this.FormAttribute)) {
      const sourceValue = this.value || this.FormAttribute.value;
      this.value = parseVulnerabilityRows(sourceValue);
    }

    if (this.FormAttribute.type === FormAttributeType.Tags) {
      const myMatchKey = TagHelpers.tagTaxonomyKeyFromFormAttribute({
        input: this.FormAttribute.input,
        label: this.FormAttribute.label,
        type: this.FormAttribute.type
      });
      this.tagTaxonomyKey = myMatchKey;

      this.subs.add(
        this.actions$
          .pipe(ofType<TagSelectorChange>(ETagSelectorActions.Change))
          .subscribe(action => {
            if (action.payload) {
              this.selectedValues[action.payload.type] = (action.payload && action.payload.id) ? action.payload.id : null;
              // Only trigger value change if this action belongs to THIS field's taxonomy
              if (action.payload.type === myMatchKey) {
                super.onValueChange();
              }
            }
          })
      );

      this.subs.add(
        this.actions$
          .pipe(ofType(ETagSelectorActions.Touched))
          .subscribe(() => {
            this.touched = true;
          })
      );

      if (this.FormAttribute.value && this.FormAttribute.value.length > 0) {
        const savedId = this.FormAttribute.value[0];
        setTimeout(() => {
          this.store.dispatch(
            new TagSelectorSetById({ id: savedId, type: myMatchKey })
          );
        }, 0);
        // Options for filter_by_parent may arrive after the first SetById.
        this.subs.add(
          this.nestedTags$
            .pipe(
              filter(
                tags =>
                  Array.isArray(tags) &&
                  tags.some(t => Number(t.id) === Number(savedId))
              ),
              take(1)
            )
            .subscribe(() => {
              this.store.dispatch(
                new TagSelectorSetById({ id: savedId, type: myMatchKey })
              );
            })
        );
      }
    }

    this.subs.add(
      this.actions$
        .pipe(
          ofType<FormAttributeUnresolvedAddress>(
            EFormAttributeActions.UnresolvedAddress
          )
        )
        .subscribe(() => {
          this.toast.show(ToastType.Danger, 'TOAST_UNRESOLVED_ADDRESS');
        })
    );

    this.subs.add(this.store.select(selectMap).subscribe(map => {
      if (map) {
        this.mapRegions = map.regions;
        this.filters = FilterHelpers.GetFilters(this.mapRegions);
      }
    })
    );

    // Position map on existing location when editing
    if (this.FormAttribute.type === FormAttributeType.Point && this.value && this.value.lat && this.value.lon) {
      setTimeout(() => {
        this.store.dispatch(new SimulateUserClickedMap({
          actual: {
            lat: this.value.lat,
            lon: this.value.lon,
            zoom: 15,
            properties: null
          }
        }));
      }, 500);
    }

    const formAttributeData = this.filters.filter(el => el.label === "FILTER_LABEL_MGMT_LEV_1");

    if (this.FormAttribute.label === RiskFilters.PROVINCE) {
      const options = [];
      formAttributeData[0].values.forEach(element => {
        options.push(element.name);
      });
      this.FormAttribute.options = options;
    }

  }

  ngOnDestroy() {
    if (this.mediaConfirmModalRef) {
      const ref = this.mediaConfirmModalRef;
      this.mediaConfirmModalRef = null;
      ref.dismiss();
    }
    this.clearPendingMediaConfirmation();
    if (this.FormAttribute) {
      delete this.FormAttribute.value;
    }
    this.subs.unsubscribe();
    super.ngOnDestroy();
  }

  isLocalImageFile(file: unknown): boolean {
    return file instanceof File && !!file.type && file.type.startsWith('image/');
  }

  isLocalPdfFile(file: unknown): boolean {
    if (!(file instanceof File)) {
      return false;
    }
    if (file.type === 'application/pdf') {
      return true;
    }
    const n = (file.name || '').toLowerCase();
    return n.endsWith('.pdf');
  }

  private revokePendingConfirmPreviewUrl(): void {
    if (this.pendingConfirmPreviewUrl) {
      URL.revokeObjectURL(this.pendingConfirmPreviewUrl);
      this.pendingConfirmPreviewUrl = null;
    }
    this.pendingConfirmImageSafe = null;
    if (this.pendingConfirmPdfBlobUrl) {
      URL.revokeObjectURL(this.pendingConfirmPdfBlobUrl);
      this.pendingConfirmPdfBlobUrl = null;
    }
    this.pendingConfirmPdfSafe = null;
  }

  private buildPendingConfirmPreview(file: File): void {
    this.revokePendingConfirmPreviewUrl();
    if (file.type.startsWith('image/')) {
      this.pendingConfirmPreviewUrl = URL.createObjectURL(file);
      this.pendingConfirmImageSafe = this.sanitizer.bypassSecurityTrustUrl(
        this.pendingConfirmPreviewUrl
      );
    } else if (
      file.type === 'application/pdf' ||
      file.name.toLowerCase().endsWith('.pdf')
    ) {
      this.pendingConfirmPdfBlobUrl = URL.createObjectURL(file);
      this.pendingConfirmPdfSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.pendingConfirmPdfBlobUrl
      );
    }
  }

  private clearPendingMediaConfirmation(): void {
    this.revokePendingConfirmPreviewUrl();
    this.pendingConfirmFile = null;
    this.pendingConfirmSlotIndex = null;
  }

  private openMediaConfirmDialog(
    file: File,
    slotIndex: number | null,
    input: HTMLInputElement
  ): void {
    if (this.mediaConfirmModalRef) {
      this.mediaConfirmModalRef.dismiss();
    }
    this.pendingConfirmFile = file;
    this.pendingConfirmSlotIndex = slotIndex;
    this.buildPendingConfirmPreview(file);
    input.value = '';
    this.cdr.detectChanges();
    setTimeout(() => {
      if (!this.mediaConfirmModalTpl) {
        this.clearPendingMediaConfirmation();
        return;
      }
      const modalRef = this.modalService.open(
        this.mediaConfirmModalTpl,
        this.mediaConfirmModalOptions
      );
      this.mediaConfirmModalRef = modalRef;
      modalRef.result.then(
        () => {},
        () => {
          if (this.mediaConfirmModalRef !== modalRef) {
            return;
          }
          this.clearPendingMediaConfirmation();
          this.mediaConfirmModalRef = null;
        }
      );
      this.cdr.detectChanges();
    }, 0);
  }

  confirmPendingMediaAttachment(): void {
    const file = this.pendingConfirmFile;
    const idx = this.pendingConfirmSlotIndex;
    const ref = this.mediaConfirmModalRef;
    if (!file) {
      ref?.dismiss();
      this.mediaConfirmModalRef = null;
      return;
    }
    if (idx === null) {
      this.value = file;
      this.touched = true;
      this.onValueChanged();
    } else if (idx === -1) {
      if (!Array.isArray(this.value)) {
        this.value = [];
      }
      this.value = [...this.value, file];
      this.touched = true;
      this.onValueChanged();
    } else {
      if (!Array.isArray(this.value)) {
        this.value = [];
      }
      const newValue = [...this.value];
      while (newValue.length <= idx) {
        newValue.push(null);
      }
      newValue[idx] = file;
      this.value = newValue;
      this.touched = true;
      this.onValueChanged();
    }
    this.revokePendingConfirmPreviewUrl();
    this.pendingConfirmFile = null;
    this.pendingConfirmSlotIndex = null;
    ref?.close();
    this.mediaConfirmModalRef = null;
  }

  cancelPendingMediaAttachment(): void {
    this.mediaConfirmModalRef?.dismiss();
  }

  private subs: Subscription;
  showDeleteConfirmation: boolean = false;
  touched: boolean = false;

  get hasValidationError(): boolean {
    return (this.FormAttribute.required && this.touched && (!this.value || (typeof this.value === 'string' && this.value.trim() === ''))) || 
           (this.value || '').length > 150 || 
           this.hasInvalidCharacters;
  }

  get formSelectOptions(): SearchableSelectOption[] {
    return (this.FormAttribute?.options || []).map(option => ({
      value: option,
      label: option
    }));
  }

  get hasSelectValidationError(): boolean {
    return this.FormAttribute.required && this.touched && (this.value == -1 || !this.value);
  }

  get hasTagValidationError(): boolean {
    return this.FormAttribute.required && this.touched && (!this.selectedValues || !this.selectedValues[this.FormAttribute.type] || this.selectedValues[this.FormAttribute.type] === 'null');
  }

  get hasDateTimeValidationError(): boolean {
    if (this.isDateTimeClientInvalid()) {
      return this.touched || !!this.FormAttribute?.clientInvalid;
    }
    if (!this.FormAttribute.required || !this.touched) {
      return false;
    }
    return this.isDateTimeEmpty();
  }

  isDateTimeEmpty(): boolean {
    if (this.requiresDateTimeTime()) {
      return !this.datetimeLocalValue;
    }
    if (this.dateOnlyValue) {
      return false;
    }
    return !this.value?.date;
  }

  get hasInvalidDateFormat(): boolean {
    if (this.requiresDateTimeTime()) {
      return !!(
        this.datetimeLocalValue && !moment(this.datetimeLocalValue).isValid()
      );
    }
    if (this.dateOnlyValue) {
      return !moment(this.dateOnlyValue, 'YYYY-MM-DD', true).isValid();
    }
    if (!this.value || !this.value.date) return false;
    // If it's an NgbDate object from datepicker, it's valid
    if (typeof this.value.date === 'object' && this.value.date.year) return false;
    
    const dateStr = this.value.date.toString();
    // Validar formato dd/mm/yyyy
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(dateStr)) return true;
    
    // Validar que sea una fecha válida
    const parts = dateStr.split('/');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    
    const date = new Date(year, month - 1, day);
    return date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day;
  }

  get hasInvalidCharacters(): boolean {
    return hasInvalidTitleText(this.value);
  }

  checkSelectOptions(FormAttribute) {
    if((FormAttribute.label === RiskFilters.WARD && FormAttribute.options && FormAttribute.options.length === 0)
      || (FormAttribute.label === RiskFilters.DISTRICT && FormAttribute.options && FormAttribute.options.length === 0)) {
        return true;
    } else {
      return false;
    }
  }
  onValueChanged() {
    super.onValueChange();
    
    // Mantener el foco en el input de búsqueda después de cambios
    if (this.FormAttribute.type === FormAttributeType.Point && this.searchInput) {
      setTimeout(() => {
        this.searchInput.nativeElement.focus();
      }, 0);
    }
    
    // For numeros_mesa, keep as array but join values with semicolon in each element
    if (this.FormAttribute.key === 'numeros_mesa' && Array.isArray(this.value)) {
      // Backend expects array format, so wrap the semicolon string in array
      this.FormAttribute.value = [this.value.join(';')];
    }
    if (isRepeatableRowsAttribute(this.FormAttribute)) {
      const catalog = resolveRowsCatalog(this.FormAttribute.config);
      const rows = Array.isArray(this.value)
        ? (this.value as VulnerabilityRow[])
        : parseVulnerabilityRows(this.value);
      const encoded = encodeVulnerabilityRows(rows, catalog);
      // Don't persist placeholder blank rows (e.g. only default range).
      this.FormAttribute.value =
        encoded === '[]' ? null : [encoded];
      this.value = rows;
    }
    if (this.FormAttribute.label === RiskFilters.PROVINCE) {
      this.getformAttributesExUpdate.emit(this.newFilterData);
    }
    if (this.FormAttribute.label === RiskFilters.DISTRICT) {
      this.getformAttributesExUpdateZone.emit(this.newFilterData);
    }
    if (this.FormAttribute.label === RiskFilters.DEPARTMENT) {
      this.getformAttributesExUpdateZone.emit(this.newFilterData);
    }
  }

  validarField(event: KeyboardEvent) {
    blockTitleTextKeypress(event);
  }

  onPaste(event: ClipboardEvent) {
    blockTitleTextPaste(event);
  }

  markAsTouched() {
    this.touched = true;
    // For tag fields, also mark nested tag-selectors as touched
    if (this.FormAttribute.type === FormAttributeType.Tags) {
      // Dispatch action to mark tag-selectors as touched
      this.store.dispatch(new TagSelectorTouched());
    }
    // For table numbers (numeros_mesa), mark the component as touched
    if (this.FormAttribute.key === 'numeros_mesa' && this.tableNumbersInput) {
      this.tableNumbersInput.markAsTouched();
    }
    if (
      isRepeatableRowsAttribute(this.FormAttribute) &&
      this.vulnerabilityRowsInput
    ) {
      this.vulnerabilityRowsInput.markAsTouched();
    }
  }

  get isRepeatableRowsField(): boolean {
    return isRepeatableRowsAttribute(this.FormAttribute);
  }

  onVulnerabilityRowsChanged(rows: VulnerabilityRow[]) {
    this.value = rows || [];
    this.onValueChanged();
  }

  get hasValidationErrorTextarea(): boolean {
    return (this.FormAttribute.required && this.touched && (!this.value || (typeof this.value === 'string' && this.value.trim() === ''))) || 
           this.hasInvalidCharactersTextarea;
  }

  get hasInvalidCharactersTextarea(): boolean {
    return hasInvalidIncidentLongText(
      typeof this.value === 'string' ? this.value : ''
    );
  }

  validarFieldTextarea(event: KeyboardEvent) {
    blockIncidentLongTextKeypress(event);
  }

  onPasteTextarea(event: ClipboardEvent) {
    blockIncidentLongTextPaste(event);
  }

  onDateTimeLocalChanged(value?: string) {
    this.touched = true;
    if (typeof value === 'string') {
      this.datetimeLocalValue = value;
    }
    this.syncDateTimeFromInputs();
    this.onValueChanged();
  }

  onDateTimeLocalFocus() {
    // Force native max/min refresh to current local clock when opening picker.
    this.cdr.markForCheck();
  }

  onDateTimeLocalBlur() {
    this.touched = true;
    this.syncDateTimeFromInputs();
    this.onValueChanged();
  }

  onDateOnlyChanged() {
    this.touched = true;
    this.syncDateTimeFromInputs();
    this.onValueChanged();
  }

  onDateTimeChange() {
    this.touched = true;
    this.syncDateTimeFromInputs();
    if (this.requiresDateTimeTime() && !this.value?.date) {
      if (this.value) {
        this.value.time = null;
      }
      this.dateTimeTimeEntered = false;
    }
    this.onValueChanged();
  }

  onDateTimeTimeChange() {
    this.touched = true;
    this.syncDateTimeFromInputs();
    this.dateTimeTimeEntered = true;
    this.onValueChanged();
  }

  validarDateField(event: KeyboardEvent) {
    const char = event.key;
    const target = event.target as HTMLInputElement;
    const currentValue = target.value;
    
    // Permitir solo números y barra diagonal
    const regex = /^[0-9\/]$/;
    if (!regex.test(char)) {
      event.preventDefault();
      return;
    }
    
    // Limitar longitud a 10 caracteres (dd/mm/yyyy)
    if (currentValue.length >= 10 && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(char)) {
      event.preventDefault();
    }
  }

  get hasLocationValidationError(): boolean {
    return this.FormAttribute.required && this.touched && (!this.value || !this.value.lat || !this.value.lon);
  }

  get showRequiredError(): boolean {
    if (!this.FormAttribute.required || !this.touched) return false;
    if (!this.value) return true;
    if (typeof this.value === 'string' && this.value.trim() === '') return true;
    if (this.value == -1) return true;
    return false;
  }

  get showRequiredErrorTextarea(): boolean {
    if (!this.FormAttribute.required || !this.touched) return false;
    if (!this.value) return true;
    if (typeof this.value === 'string' && this.value.trim() === '') return true;
    return false;
  }

  get hasMediaValidationError(): boolean {
    if (!this.FormAttribute.required || !this.touched) return false;
    if (this.FormAttribute.cardinality > 1) {
      return this.uploadedFilesCount === 0;
    }
    return !this.value || !this.value.name;
  }

  get showRequiredErrorMedia(): boolean {
    if (!this.FormAttribute.required || !this.touched) return false;
    if (this.FormAttribute.cardinality > 1) {
      return this.uploadedFilesCount === 0;
    }
    return !this.value || !this.value.name;
  }

  getMediaArray(): any[] {
    if (!this.FormAttribute.cardinality || this.FormAttribute.cardinality <= 1) {
      return [];
    }
    if (!Array.isArray(this.value)) {
      this.value = [];
    }
    return this.value;
  }

  get uploadedFilesCount(): number {
    if (!Array.isArray(this.value)) return 0;
    return this.value.filter(f => f && f.name).length;
  }

  isPdfLikeMedia(item: unknown): boolean {
    if (this.isLocalPdfFile(item)) {
      return true;
    }
    if (item && typeof item === 'object' && (item as { name?: string }).name) {
      return String((item as { name: string }).name)
        .toLowerCase()
        .endsWith('.pdf');
    }
    return false;
  }

  isImageLikeMedia(item: unknown): boolean {
    if (this.isLocalImageFile(item)) {
      return true;
    }
    if (item && typeof item === 'object' && (item as { name?: string }).name) {
      const n = String((item as { name: string }).name).toLowerCase();
      return /\.(jpe?g|png)$/.test(n);
    }
    return false;
  }

  /** Single file input for multi-cardinality: pick → modal → append to `value`. */
  async onMediaMultiStackSelect(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }

    if (this.uploadedFilesCount >= this.FormAttribute.cardinality) {
      input.value = '';
      this.toast.show(ToastType.Warning, 'FORM_MEDIA_MAX_FILES', true, 5000, {
        max: this.FormAttribute.cardinality
      });
      return;
    }

    this.fileSizeError = false;
    this.fileTypeError = false;
    this.fileCorruptError = false;

    const kind =
      this.FormAttribute.key === 'analisis_archivo' ? 'pdf' : 'pdf-or-image';
    const result = await assertReadableUploadFile(file, {
      kind,
      maxMb: this.MAX_SIZE_MB
    });
    if (result.ok === false) {
      if (result.errorKey === 'FILE_SIZE_EXCEEDED') {
        this.fileSizeError = true;
      } else if (result.errorKey === 'FILE_CORRUPT_OR_UNREADABLE') {
        this.fileCorruptError = true;
      } else {
        this.fileTypeError = true;
      }
      input.value = '';
      this.toast.show(ToastType.Danger, this.mediaUploadErrorKey(result.errorKey, kind));
      return;
    }

    if (!Array.isArray(this.value)) {
      this.value = [];
    }

    this.openMediaConfirmDialog(file, -1, input);
  }

  // Sobrescribir onMediaSelect para validaciones específicas de análisis_archivo
  async onMediaSelect(event: { target: { files: any } }) {
    const input = event.target as HTMLInputElement;
    this.fileSizeError = false;
    this.fileTypeError = false;
    this.fileCorruptError = false;

    if (!input?.files?.length) {
      return;
    }
    const file = input.files[0];
    const kind =
      this.FormAttribute.key === 'analisis_archivo' ? 'pdf' : 'pdf-or-image';
    const result = await assertReadableUploadFile(file, {
      kind,
      maxMb: this.MAX_SIZE_MB
    });
    if (result.ok === false) {
      if (result.errorKey === 'FILE_SIZE_EXCEEDED') {
        this.fileSizeError = true;
        this.value = '';
      } else if (result.errorKey === 'FILE_CORRUPT_OR_UNREADABLE') {
        this.fileCorruptError = true;
      } else {
        this.fileTypeError = true;
      }
      input.value = '';
      this.toast.show(ToastType.Danger, this.mediaUploadErrorKey(result.errorKey, kind));
      return;
    }

    this.openMediaConfirmDialog(file, null, input);
  }

  private mediaUploadErrorKey(
    errorKey: string,
    kind: 'pdf' | 'pdf-or-image'
  ): string {
    if (errorKey === 'FILE_SIZE_EXCEEDED') {
      return 'ANALISIS_FILE_SIZE_ERROR';
    }
    if (errorKey === 'FILE_CORRUPT_OR_UNREADABLE') {
      return 'FILE_CORRUPT_OR_UNREADABLE';
    }
    // FILE_TYPE_NOT_ALLOWED, FILE_CONTENT_MISMATCH, etc.
    return kind === 'pdf' ? 'ANALISIS_FILE_TYPE_PDF' : 'FILE_TYPE_PDF_OR_IMAGE';
  }

  isMediaSlotFilled(file: any): boolean {
    return !!(file && (file as { name?: string }).name);
  }

  removeMediaFile(index: number) {
    if (!Array.isArray(this.value)) {
      this.value = [];
    }
    const newValue = [...this.value];
    newValue.splice(index, 1);
    this.value = newValue;

    this.touched = true;
    this.onValueChanged();

    const inputId = `media-multi-input-${this.FormAttribute.id}`;
    setTimeout(() => {
      const el = document.getElementById(inputId) as HTMLInputElement | null;
      if (el) {
        el.value = '';
      }
    }, 0);
  }

}
